import React from 'react';
import styled from '@emotion/styled';

const Group = ({ children, ...rest }) => {
	const GroupDiv = styled.div`
		& > * {
			margin-right: 10px;
		}
	`;
	return <GroupDiv {...rest}>{children}</GroupDiv>;
};

export default Group;
